function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Form, Input, Button, Space, Alert } from "antd";
import { Spinner } from "react-bootstrap";
import Common from "../../components/includes/Common";
import { useNavigate } from 'react-router-dom';
import { LockFill } from "react-bootstrap-icons";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var AdminLogin = function AdminLogin() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormError = _useState4[0],
    setIsFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var navigate = useNavigate();
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setIsFormError(false);
    setErrorMessage('');
    var formData = new FormData();
    formData.append('sulogin', values.sulogin);
    formData.append('supassword', values.supassword);
    axios.post(Common.baseApiUrl + 'login', formData).then(function (response) {
      setIsFormProcessing(false);
      if (response.data.status == 200) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        navigate('/az/panel/manage-events');
        //location.reload(); 
      } else {
        setIsFormError(true);
        setErrorMessage(response.data.message);
        console.log(response.data.status.toString());
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setIsFormError('Une erreur est survenue');
    });
  };
  useEffect(function () {
    if (Common.currentUser != 'undefined' && Common.currentUser != null) {
      axios.post(Common.baseApiUrl + "authenticateuser", {
        id: Common.currentUser.id
      }).then(function (response) {
        if (response.data.auth == true) {
          localStorage.setItem('userData', JSON.stringify(response.data.user));
          localStorage.setItem('isOn', true);
          navigate("/az/panel/manage-events");
        }
      })["catch"](function (error) {});
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      fluid: true,
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          className: "az-login-box",
          lg: 4,
          md: 5,
          sm: 7,
          xs: 8,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              verticalAlign: 'center',
              padding: '200px 20px'
            },
            children: [/*#__PURE__*/_jsx("h3", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx(LockFill, {})
            }), /*#__PURE__*/_jsxs(Form, {
              layout: "vertical",
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                label: "Login",
                name: "sulogin",
                rules: [{
                  required: true,
                  message: 'Le login est bligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {})
              }), /*#__PURE__*/_jsx(Form.Item, {
                label: "Mot de passe",
                name: "supassword",
                rules: [{
                  required: true,
                  message: 'Veuillez entrer le mot de passe'
                }],
                children: /*#__PURE__*/_jsx(Input.Password, {})
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "subm",
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Entrer"
                    })
                  })
                }), isFormProcessing ? /*#__PURE__*/_jsx(Spinner, {
                  animation: "grow",
                  variant: "secondary"
                }) : /*#__PURE__*/_jsx(_Fragment, {})]
              }), /*#__PURE__*/_jsx("br", {}), errorMessage.length ? /*#__PURE__*/_jsx(Alert, {
                banner: true,
                type: "error",
                message: errorMessage
              }) : /*#__PURE__*/_jsx(_Fragment, {})]
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 4,
            offset: 3
          },
          md: 6,
          sm: 5,
          xs: 4,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: 'center',
              verticalAlign: 'center',
              padding: '200px 20px'
            },
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("img", {
                src: "drawables/nl1_rm.png",
                style: {
                  width: '100%'
                }
              })
            })
          })
        })]
      })
    })
  });
};
export default AdminLogin;